var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"aa-home"},[_c('Banner'),_c('DoCard'),_c('PrintingCard'),_c('FreshArtSlider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }